module.exports = __webpack_public_path__ + "img/brand-9.89b5975a.png";